export const GET_EMAIL_REQUEST = "GET_EMAIL_REQUEST";
export const GET_EMAIL_SUCCESS = "GET_EMAIL_SUCCESS";
export const GET_EMAIL_FAILURE = "GET_EMAIL_FAILURE";
